import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import './Radio.css';

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: ReactNode;
}

/** A real native `<input type="radio">`, visually restyled. */
export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { label, className, id, ...rest },
  ref
) {
  return (
    <label className={['dpr-radio', className].filter(Boolean).join(' ')}>
      <input ref={ref} type="radio" id={id} className="dpr-radio__input" {...rest} />
      <span className="dpr-radio__circle" aria-hidden="true" />
      <span className="dpr-radio__label">{label}</span>
    </label>
  );
});
